import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Enterprise } from '../models/enterprise';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
  ) { }

  getEnterpriseById(id: string): Observable<Enterprise> {
    if (id === '' || !environment.selected.cnpj) {
      return of();
    }

    return this.http.get<Enterprise>(environment.sso + '/empresa/' + environment.selected.cnpj + '/' + id)
      .pipe(
        catchError(err => of(err.erro))
      );
  }

  updateEnterprise(id: string, enterprise: Enterprise): Observable<Enterprise> {
    return this.http.put<Enterprise>(environment.sso + '/empresa/' + environment.selected.cnpj + '/' + id,
      enterprise, this.httpOptions)
      .pipe(
        catchError(err => of('error' in err ? err.error : err))
      );
  }
}
